import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

const Auth = ({ mode = "login" }) => {
    const isLogin = mode === "login";
    const { login, register } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [fullName, setFullName] = useState("");
    const [inviteCode, setInviteCode] = useState("");
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptPrivacy, setAcceptPrivacy] = useState(false);
    const [marketing, setMarketing] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!isLogin && (!acceptTerms || !acceptPrivacy)) {
            toast.error("Devi accettare Privacy e Termini per iscriverti");
            return;
        }
        setLoading(true);
        try {
            if (isLogin) {
                const user = await login(email, password);
                toast.success(`Bentornato, ${user.full_name}`);
                nav(user.onboarded ? "/feed" : "/onboarding");
            } else {
                await register(email, password, fullName, { accept_terms: acceptTerms, accept_privacy: acceptPrivacy, marketing_optin: marketing, invite_code: inviteCode });
                toast.success("Account creato. Benvenuto nel network!");
                nav("/onboarding");
            }
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Errore");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-bg flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <Link to="/" className="flex justify-center mb-8">
                    <Logo />
                </Link>
                <div className="bg-paper rounded-2xl border border-border-line soft-shadow-lg p-8 md:p-10">
                    <h1 className="font-heading text-4xl mb-2 text-ink">{isLogin ? "Bentornato" : "Iscriviti"}</h1>
                    <p className="text-sm text-muted mb-8">
                        {isLogin ? "Entra nel salotto dei professionisti." : "L'iscrizione è gratuita e su invito: inserisci il codice d'accesso che hai ricevuto da Voci di Imprese."}
                    </p>
                    <form onSubmit={submit} className="space-y-4">
                        {!isLogin && (
                            <div>
                                <label className="text-xs uppercase tracking-widest text-muted">Codice d'invito</label>
                                <input data-testid="auth-invite" required value={inviteCode} onChange={(e) => setInviteCode(e.target.value.toUpperCase())} className="input-clean mt-1 font-mono tracking-wider" placeholder="VDI-XXXX-XXXX" autoComplete="off" />
                            </div>
                        )}
                        {!isLogin && (
                            <div>
                                <label className="text-xs uppercase tracking-widest text-muted">Nome e cognome</label>
                                <input data-testid="auth-name" required value={fullName} onChange={(e) => setFullName(e.target.value)} className="input-clean mt-1" placeholder="Mario Rossi" />
                            </div>
                        )}
                        <div>
                            <label className="text-xs uppercase tracking-widest text-muted">Email</label>
                            <input data-testid="auth-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-clean mt-1" placeholder="tu@email.it" />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-widest text-muted">Password</label>
                            <input data-testid="auth-password" required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-clean mt-1" placeholder="Almeno 6 caratteri" />
                        </div>

                        {!isLogin && (
                            <div className="space-y-2 pt-2 text-sm">
                                <label className="flex items-start gap-2 cursor-pointer">
                                    <input data-testid="accept-privacy" type="checkbox" checked={acceptPrivacy} onChange={(e) => setAcceptPrivacy(e.target.checked)} className="mt-1 w-4 h-4 accent-bordeaux" required />
                                    <span className="text-muted">Ho letto e accetto la <Link to="/privacy-policy" target="_blank" className="text-bordeaux hover:underline">Privacy Policy</Link> *</span>
                                </label>
                                <label className="flex items-start gap-2 cursor-pointer">
                                    <input data-testid="accept-terms" type="checkbox" checked={acceptTerms} onChange={(e) => setAcceptTerms(e.target.checked)} className="mt-1 w-4 h-4 accent-bordeaux" required />
                                    <span className="text-muted">Accetto i <Link to="/terms" target="_blank" className="text-bordeaux hover:underline">Termini e Condizioni</Link>, inclusa la licenza d'uso dei contenuti che caricherò (dichiaro di possederne i diritti) *</span>
                                </label>
                                <label className="flex items-start gap-2 cursor-pointer">
                                    <input data-testid="marketing-optin" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-1 w-4 h-4 accent-bordeaux" />
                                    <span className="text-muted">Voglio ricevere aggiornamenti e novità dal network (facoltativo)</span>
                                </label>
                            </div>
                        )}

                        <button data-testid="auth-submit" disabled={loading} className="btn-primary w-full justify-center mt-2">
                            {loading ? "Attendi…" : isLogin ? "Accedi" : "Crea account"}
                        </button>
                    </form>
                    <div className="mt-6 text-sm text-muted text-center">
                        {isLogin ? (
                            <>Non hai un account? <Link to="/register" data-testid="auth-switch" className="text-bordeaux hover:underline">Iscriviti</Link></>
                        ) : (
                            <>Hai già un account? <Link to="/login" data-testid="auth-switch" className="text-bordeaux hover:underline">Accedi</Link></>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Auth;
